import { render } from "./MeusDados.vue?vue&type=template&id=ce37b5e2&ts=true"
import script from "./MeusDados.vue?vue&type=script&lang=ts"
export * from "./MeusDados.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__